import React from 'react'
import { NavLink } from 'react-router-dom'
import { Layout, Menu, Button } from 'antd'
import { useAuth } from '../../authContext'
import { appVersion, department } from '../../config'
import { ReactComponent as Logo } from '../../assets/logo.svg';

const { Header, Content, Footer } = Layout

const userName = (user) => {
  const name = user.name ? user.name : user.upn;
  if (name.includes("@")) {
    return name.split("@")[0];
  }
  return name;
};

const Frame = props => {
  const { isAuthenticated, logout, user } = useAuth()

  if (!isAuthenticated) return <div>{props.children}</div>

  return (
    <Layout>
      <Header className="headerBar">
        <div className="logoContainer">
          <Logo className="logo" alt="Arctic" />
          <span>{department.shortName}</span>
        </div>
        <Menu theme="light" mode="horizontal" style={{ lineHeight: '64px' }}>
          <Menu.Item key="Upload">
            <NavLink to="/">Upload</NavLink>
          </Menu.Item>
          <Menu.Item key="Display">
            <NavLink to="/admin">Display</NavLink>
          </Menu.Item>
        </Menu>
        <div className="userBox">
            {!isAuthenticated && (
              <Button onClick={() => { window.location.href = '/auth/login' }}>Log in</Button>
            )}

            {isAuthenticated && (
              <>
                <span className="userName">Hi {userName(user)}!</span>
                <Button onClick={() => logout()}>Log out</Button>
              </>
            )}
          </div>
      </Header>
      <Content className="frameContent">{props.children}</Content>

      <Footer>
        <div className="stdContent footerContent">
          <div>Digital-sign - {department.name}</div>
          <div className="appVersion">{appVersion}</div>
        </div>
      </Footer>
    </Layout>
  )
}

export default Frame
